import orderBy from 'lodash/orderBy';
import { scrollToElement } from '../../../utils/scrollToElement';

const MARGIN_TOP = 10;

interface ValidationMarker {
  input: HTMLElement;
  error?: string;
  required?: string;
}

const scrollToErrorMarker = (hasErrors: boolean, shouldScrollToRequiredFields: boolean): void => {
  const inputs = document.querySelectorAll<HTMLInputElement | HTMLDivElement>(
    '[role="radiogroup"], input, .etiDropdown, .etiSelectBox, .etiToggleBarButton, .etiRadioGroup',
  );

  const validationMarkers: ValidationMarker[] = Array.from(inputs).reduce<ValidationMarker[]>(
    (acc, input) => {
      if (
        hasErrors &&
        (input.classList.contains('error') || input.getAttribute('aria-invalid') === 'true')
      ) {
        return [...acc, { error: 'error', input }];
      }

      if (input.classList.contains('required')) {
        return [...acc, { required: 'required', input }];
      }

      return acc;
    },
    [],
  );

  const [errorMarker] = orderBy(
    validationMarkers,
    shouldScrollToRequiredFields ? ['required', 'error'] : ['error'],
    ['asc'],
  );

  if (errorMarker?.input) {
    const targetSection =
      errorMarker.input.closest('.travelerDetailsSection') ||
      errorMarker.input.closest('[data-contactinfoscrollanchor]') ||
      errorMarker.input.closest('[data-agentinformationscrollanchor]') ||
      errorMarker.input;
    scrollToElement(targetSection, MARGIN_TOP);
  }
};

export default scrollToErrorMarker;
